/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

export const FcsPermissionManagementLoginApproval = {
  permission_management_login_approval_enable: new FcsFlag.Flag(false),
  permission_tab_approval_enable: new FcsFlag.Flag(false),
  permission_action_approve_enable: new FcsFlag.Flag(false),
  permission_action_reject_enable: new FcsFlag.Flag(false),
  permission_tab_device_enable: new FcsFlag.Flag(false),
  permission_action_delete_device_enable: new FcsFlag.Flag(false),
  permission_tab_history_enable: new FcsFlag.Flag(false)
};

export const initFlagsPermissionManagementLoginApproval = () => {
  FcsFlag.register(
    "flagManagementLoginApproval",
    FcsPermissionManagementLoginApproval
  );
};
